import useModuleFilters from '../../../shared/data/useModuleFilters';
import FilterBar from '../../../shared/components/patterns/FilterBar';
import { notificationSchema } from '../adminFilter.schemas';
import { useEffect, useState } from 'react';
import { listAdminAuditLogs } from '@/modules/admin/services/admin-audit-logs.service';

function getNotificationVariant(log) {
  if (log.outcome === 'FAILURE' || /FAILED|ERROR/.test(log.actionCode || '')) {
    return 'is-danger';
  }
  if (log.outcome === 'SUCCESS' && /DELETE|DELETED|DISABLED|INVITE/.test(log.actionCode || '')) {
    return 'is-warning';
  }
  if (log.outcome === 'SUCCESS') {
    return 'is-success';
  }
  return '';
}

export default function AdminNotificationsPage() {
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  async function loadLogs() {
    setIsLoading(true);
    const result = await listAdminAuditLogs({ limit: 10 });

    if (!result.ok) {
      setError(result.message);
      setLogs([]);
      setIsLoading(false);
      return;
    }

    setLogs(result.data);
    setError('');
    setIsLoading(false);
  }

  useEffect(() => {
    let active = true;

    async function load() {
      const result = await listAdminAuditLogs({ limit: 10 });
      if (!active) {
        return;
      }

      if (!result.ok) {
        setError(result.message);
        setLogs([]);
        setIsLoading(false);
        return;
      }

      setLogs(result.data);
      setError('');
      setIsLoading(false);
    }

    load();

    return () => {
      active = false;
    };
  }, []);

  const moduleFilters = useModuleFilters({ schema: notificationSchema, rows: logs });
  const filteredRows = moduleFilters.filterRows(logs);

  return (
    <section className="control-plane-page">
      <header className="control-plane-topbar">
        <div>
          <div className="control-plane-topbar__title">Notifiche</div>
          <div className="control-plane-topbar__subtitle">
            Feed operativo derivato dagli audit log control plane
          </div>
        </div>
        <div className="control-plane-topbar__actions">
          <button type="button" className="control-plane-button" onClick={loadLogs}>
            Aggiorna feed
          </button>
        </div>
      </header>

      <div className="control-plane-content">
        <section className="control-plane-metrics control-plane-metrics--3">
          <article className="control-plane-metric">
            <div className="control-plane-metric__label">Notifiche totali</div>
            <div className="control-plane-metric__value">{logs.length}</div>
            <div className="control-plane-metric__support">ultimi eventi audit caricati</div>
          </article>
          <article className="control-plane-metric control-plane-metric--attention">
            <div className="control-plane-metric__label">Failure</div>
            <div className="control-plane-metric__value">{logs.filter((log) => log.outcome === 'FAILURE').length}</div>
            <div className="control-plane-metric__support">eventi con esito negativo</div>
          </article>
          <article className="control-plane-metric control-plane-metric--success">
            <div className="control-plane-metric__label">Success</div>
            <div className="control-plane-metric__value">{logs.filter((log) => log.outcome === 'SUCCESS').length}</div>
            <div className="control-plane-metric__support">eventi informativi o completati</div>
          </article>
        </section>
        <FilterBar model={moduleFilters} />


        <section className="control-plane-card">
          {isLoading ? <div className="control-plane-empty-state">Caricamento notifiche operative...</div> : null}
          {!isLoading && error ? <div role="alert" className="control-plane-inline-error wt-inline-error">{error}</div> : null}
          {!isLoading && !error && logs.length === 0 ? (
            <div className="control-plane-empty-state">Nessuna notifica reale disponibile.</div>
          ) : null}
          {!isLoading && !error && logs.length > 0 ? (
            <div className="control-plane-notification-list">
              {filteredRows.map((log) => (
                <article key={log.id} className={`control-plane-notification-item ${getNotificationVariant(log)}`}>
                  <div className="control-plane-notification-item__dot" />
                  <div>
                    <div className="control-plane-notification-item__title">
                      {log.actionCode || 'Evento control plane'}
                    </div>
                    <div className="control-plane-notification-item__body">
                      Tenant: {log.tenantId || 'platform-root'} · Actor: {log.actorEmail || 'dato non disponibile'}
                    </div>
                    <div className="control-plane-notification-item__meta">
                      <span className="control-plane-badge">{log.outcome || 'UNKNOWN'}</span>
                      <span className="control-plane-badge">{log.targetType || 'event'}</span>
                      <span className="control-plane-badge">{log.occurredAt || '—'}</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          ) : null}
        </section>
      </div>
    </section>
  );
}
